import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import BarChart from "app/components/charts/BarChart";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import StackedBarChart from "./StackedBarChart";
import JobTypeDropdown from "app/components/common/JobTypeDropdown";
import { getTickInterval } from "app/utils";

import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { logActivity } from "../../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

class AgeJobCounts extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  // Handle Hover functionality in screen 3
  // handleHover = (category) => {
  //   logActivity({
  //     screen: UserActivityConstants.SCREEN3.NAME,
  //     action: UserActivityConstants.SCREEN3.ACTIONS.HOVER.AGE_GROUP,
  //     action_target: category,
  //     action_type: UserActivityConstants.ACTION_TYPES.HOVER
  //   });
  // }

  addPropsToSeriesCountChart(series) {
    let colors = ["#6AA4DC"];
    return series.map((el, i) => ({
      ...el,
      color: colors[i],
      borderColor: colors[i],
      point: {
        events: {
          mouseOver: (event) => {
            const category = event.target.category;
            // this.handleHover(category);
          }
        }
      }
    }));
  }
  

  render() {
    let age_data = [
      {
        name: "Age wise job count",
        data: this.props.countData["data"],
      },
    ];

    let totalJobCount = this.props.countData["data"].reduce((a, b) => a + b, 0);
    let minCountData = 0;
    let maxCountData = 1000;
    let countTickInterval = 100;
    if (this.props.countData["data"]) {
      minCountData = Math.min(...this.props.countData["data"]);
      minCountData = parseFloat(minCountData.toFixed(2));

      maxCountData = Math.max(...this.props.countData["data"]);
      maxCountData = parseFloat(maxCountData.toFixed(2));

      countTickInterval = parseInt(
        Math.abs(Math.abs(maxCountData) - Math.abs(minCountData)) / 10
      );
    }

    let countIntervalPower = String(maxCountData).length;
    let roundTo = 1000;
    if (countIntervalPower <= 4) {
      roundTo = Math.pow(10, countIntervalPower - 1);
      if (maxCountData < 5 * Math.pow(10, countIntervalPower - 1)) {
        roundTo = Math.pow(10, countIntervalPower - 2);
      }
    }
    countTickInterval = getTickInterval(0, maxCountData, 8, roundTo);
    // parseFloat(countTickInterval / Math.pow(10, countIntervalPower - 1)) * Math.pow(10, countIntervalPower - 1);
    return (
      <div className="graph-wrapper screen-left-graph-container">
        <div className="graph-title-container-screen graph-title-container-screen3">
          <div className="graph-dropdown graph-dropdown-3">
            <FormControl sx={{ width: "290px", marginTop: "20px" }}>
              {/* <Typography variant="inherit" className="form-metrics-header">
                Industry
              </Typography> */}
              <Select
                value={this.props.industryTypeSelected}
                onChange={this.props.handleIndustryTypeChange}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                // MenuProps={{ PaperProps: { sx: { maxHeight: "400px" } } }}
                className="select-mui"
                displayEmpty
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,

                  PaperProps: {
                    sx: { maxHeight: "400px" },
                  },
                }}
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select an Industry
                  </Typography>
                </MenuItem>
                {this.props.industryTypes.length
                  ? this.props.industryTypes.map((name, i) => (
                      <MenuItem key={i} value={name}>
                        <Typography variant="inherit" noWrap>
                          {name}
                        </Typography>
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </div>
          <JobTypeDropdown></JobTypeDropdown>
        </div>
        <div className="graph-screen graph-screen3">
          <div className="graph-title" style={{ paddingBottom: "20px" }}>Age Distribution</div>
          {this.props.countData && hasData(this.props.countData) ? (
            <StackedBarChart
              containerId="stackChart"
              stacking="normal"
              // onHover = {this.handleHover}
              remainingOptions={{
                chart: {
                  animation: false,
                  type: "bar",
                  backgroundColor: "transparent",
                  height: 595,
                  width: 700,
                  spacingTop: 20,
                  marginRight: 40,
                  dataLabels: false,
                },
                series: this.addPropsToSeriesCountChart(age_data),
                xAxis: {
                  scrollbar: {
                    enabled: true,
                  },
                  categories: this.props.countData["labels"],
                  title: {
                    text: null,
                  },
                  labels: {
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                },
                yAxis: {
                  scrollbar: {
                    enabled: true,
                  },
                  offset: 10,
                  title: {
                    text: "Workers",
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                      letterSpacing: "0.49px",
                    },
                  },
                  labels: {
                    overflow: "justify",
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                    formatter: function() {
                      return (this.value >= 1000) ? (this.value / 1000) + 'K' : this.value;
                    }
                  },
                  tickInterval: countTickInterval,
                  min: 0,
                  gridLineWidth: 0.5,
                },
                exporting: { enabled: false },
                tooltip: {
                  borderRadius: 15,
                  borderWidth: 1,
                  borderColor: "#707070",
                  backgroundColor: "#FFFFFF",
                  padding: 17,
                  shape: "square",
                  style: {
                    font: "Arial",
                    fontSize: "14px",
                    color: "#333333",
                    lineHeight: 25,
                    zIndex: 999,
                  },
                  formatter() {
                    let response = `${this.key}: <b>${this.y.toLocaleString(
                      "en-US"
                    )}</b> ( ${parseFloat(
                      ((this.y / totalJobCount) * 100).toFixed(2)
                    )}% )<br/>`;
                    return response;
                  },
                },
              }}
            />
          ) : (
            <div style={{ textAlign: "center", paddingTop: "400px" }}>
              {" "}
              No data available{" "}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function hasData(chartData) {
  let hasNodata = true;
  if (chartData.data.length == 0) {
    return false;
  }

  chartData.data.forEach((elem) => {
    if (elem != null) {
      hasNodata = false;
    }
  });
  return !hasNodata;
}

export default AgeJobCounts;
